import { render, staticRenderFns } from "./AttachmentsList.vue?vue&type=template&id=2ad6b6a5&scoped=true"
import script from "./AttachmentsList.vue?vue&type=script&lang=ts"
export * from "./AttachmentsList.vue?vue&type=script&lang=ts"
import style0 from "./AttachmentsList.vue?vue&type=style&index=0&id=2ad6b6a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ad6b6a5",
  null
  
)

export default component.exports